<template>
  <div>
    <div class="row">
      <div class="col-xs-12 buttons" :class="largeScreenColumns">
        <div v-for="(items, k) in list"
             class="selector"
             :class="isTarget(items) ? 'selected' : ''"
             :key="k">
          <a role="button"
            :type="isTarget(items) ? 'success' : 'primary'"
            @click="target=items">
            <div class="logo-container">
              <img :src="require(`@/assets/img/${items.logo}`)"
                   class="img-responsive col-xs-12 logo">
            </div>
          </a>
          <strong role="button" class="txt-dark-bactADI">{{ items.name }}</strong>
        </div>
      </div>
    </div>
    <div v-if="target">
      <hr />
      <div class="row">
        <div class="logo-container">
          <img :src="require(`@/assets/img/${target.logo}`)"
              class="img-responsive col-xs-12 logo">
        </div>
      </div>
      <hr />
      <div class="row cards" v-if="target.cards.length > 0">
        <div v-for="(card, k) in target.cards"
              :key="`${target.name}-${k}`"
              class="col-xs-12 col-md-6">
          <div class="panel panel-bactADI">
            <div class="panel-heading text-center">
              <h2 class="panel-title">
                <strong>{{ card.title }}</strong>
              </h2>
            </div>
            <div class="panel-body">
              <ul>
                <div v-for="(item, k) in card.items"
                  :key="k">
                  <link-block :link="item.link"
                              :description="item.description"
                              :title="item.title"
                              class="fb-bactADI"
                              :text="item.text"
                              :icon="item.icon">
                  </link-block>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-xs-12 col-md-6 col-md-offset-3">
          <alert type="warning" class="text-center">
            <p>
              <strong>
                Communications à venir.
              </strong>
            </p>
          </alert>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import linkBlock from '@/components/linkBlock'

export default {
  name: 'trombi',
  props: {
    list: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      target: this.list.length > 0 ? this.list[0] : null
    }
  },

  methods: {
    isTarget: function (items) {
      return this.target === items
    }
  },

  computed: {
    largeScreenColumns: function () {
      const count = this.list.length
      if (count > 8) {
        return 'col-lg-8 col-lg-offset-2'
      }
      return ''
    }
  },

  components: {
    'link-block': linkBlock
  }
}
</script>
<style scoped lang="less">
@import '~variables';

  .selector {
    width: 140px;
    transition: all .3s ease-in-out;
    padding: 0.3rem;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #cccccc00;

    .btn {
      border: none;
    }

    .logo-container {
      .logo {
        height: 80px;
      }
    }
  }

  .selected {
    border: 2px solid @brand-success;
  }

  .selector:hover {
    transform: scale(1.1);
  }

  .buttons {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .logo-container {
    display: flex;
    justify-content: center;
    img {
      object-fit: contain;
    }
  }

  .logo {
    width: unset;
    height: 119px;
    border-radius: 10%;
  }

  .cards {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  ul {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  h2.panel-title {
    font-size: 150%;
  }
</style>
